import React, { useState } from 'react';
import {
  EuiHeaderSectionItemButton,
  EuiButton,
  EuiFlexItem,
  EuiAvatar,
  EuiPopover,
  EuiFlexGroup,
  EuiText,
  EuiSpacer,
} from '@elastic/eui';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutFromSession } from '../../features/auth/auth.thunk';



export const HeaderUserMenu = ({ user }) => {

  const dispatch = useDispatch()
  const history = useHistory()

  const headerUserPopoverId = 'headerUserPopover';
  const { name, email, role } = user;
  const [isOpen, setIsOpen] = useState(false);

  const onMenuButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () =>
    setIsOpen(false);


  const logOutUser = () => {
    dispatch(logoutFromSession());
    history.push("/auth/login")
  }

  const button = (
    <EuiHeaderSectionItemButton
      aria-controls={headerUserPopoverId}
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label="Account menu"
      onClick={onMenuButtonClick}
    >
      <EuiAvatar name={name} size="s" />
    </EuiHeaderSectionItemButton>
  );

  return (
    <EuiPopover
      id={headerUserPopoverId}
      button={button}
      isOpen={isOpen}
      anchorPosition="downRight"
      closePopover={closeMenu}
      panelPaddingSize="none"
    >
      <div style={{ width: 320 }}>
        <EuiFlexGroup gutterSize="m" className="euiHeaderProfile" responsive={false}>
          <EuiFlexItem grow={false}>
            <EuiAvatar size="xl" name={name} />
            {/* <EuiAvatar name="John Username" size="xl" color="plain"  /> */}
          </EuiFlexItem>

          <EuiFlexItem>
            <EuiText size="xs">
              <h3>{name}  <h4>( {role} ) </h4>  </h3>
              <p>{email}</p>
            </EuiText>

            <EuiSpacer size="m" />

            <EuiFlexGroup>
              <EuiFlexItem>
                <EuiFlexGroup justifyContent="spaceBetween">
                  <EuiFlexItem grow={false}></EuiFlexItem>

                  <EuiFlexItem grow={false}>
                    <EuiButton color={'danger'} onClick={() => logOutUser()} size="s" >
                      Log Out
                    </EuiButton>
                  </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </div>
    </EuiPopover>
  );
};
